import {IGooglePay} from './interfaces/IGooglePay';

class GooglePay implements IGooglePay {
  async canMakePaymentsGooglePay(processorType: string, processorKey: string) {
    return false;
  }

  async presentGooglePay(
    amount: number,
    currency_code: string,
    processor: number,
    processorKey: string,
  ): Promise<string> {
    return '';
  }
}

export default new GooglePay();
